import React, { useState, useEffect, useCallback } from "react";
import { api } from "../../lib/api";
import { fmtDateTime } from "../../lib/dates";
import { Button, EmptyState, Alert } from "../../components";

// Notifications.
//
// Worth knowing: nothing in the product writes to this table. The read endpoints
// exist and work, but there is no INSERT anywhere in the codebase, so the empty state
// below is what most people will see. It is built properly for that reason rather
// than treated as an edge case.
const NotificationsScreen = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const data = await api.get("s1/api/notifications?limit=50");
      setItems(Array.isArray(data) ? data : data?.notifications || []);
      setError("");
    } catch (e) {
      setError(e.message || "Could not load notifications.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const markAllRead = async () => {
    // Optimistic: the list is already on screen and refetching to confirm a read flag
    // would flash the whole page for a change the user just asked for.
    setItems((prev) => prev.map((n) => ({ ...n, is_read: 1 })));
    try { await api.post("s1/api/notifications/read-all"); }
    catch { load(); }
  };

  const hasUnread = items.some((n) => !n.is_read);

  return (
    <div className="v2-page">
      <div className="v2-pagehead">
        <div><h2>Notifications</h2></div>
        {hasUnread && <div className="v2-pagehead-actions"><Button onClick={markAllRead}>Mark all as read</Button></div>}
      </div>

      <Alert>{error}</Alert>

      {loading ? null : items.length === 0 ? (
        <EmptyState title="Nothing yet">You are all caught up.</EmptyState>
      ) : (
        <div className="v2-tablewrap">
          <table className="v2-table">
            <tbody>
              {items.map((n) => (
                <tr key={n.notification_id} style={{ opacity: n.is_read ? 0.65 : 1 }}>
                  <td style={{ width: 18 }}>
                    <span aria-hidden="true" style={{
                      display: "block", width: 6, height: 6, borderRadius: "50%",
                      background: n.is_read ? "transparent" : "var(--v2-accent)",
                    }} />
                  </td>
                  <td>{n.message}</td>
                  <td className="v2-dim" style={{ whiteSpace: "nowrap" }}>{fmtDateTime(n.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default NotificationsScreen;
